import KeyIcon from '@mui/icons-material/Key';
import { Tooltip, IconButton, Drawer, Card, CardHeader, CardContent, Grid, useMediaQuery, Button, Divider, Stack, Alert } from "@mui/material";
import { FC, useCallback, useState } from "react";
import { useDispatch } from 'react-redux';
import ReadonlyField from '@/components/input/ReadonlyField';
import Create from '@/controller/Create';
import { useDefaultSavedHandlers } from '@/controller/defaultSavedHandlers';
import WithSave from '@/controller/WithSave';
import { UserResponseDto, UserStatus } from '@/gen/api/user';
import { autoCopyTextFieldProps } from '@/utils/clipboard';


const GenOTPPassword: FC<{user: UserResponseDto}> = ({
  user,
}) => {
  const match = useMediaQuery('(max-width: 530px)')
  const width = match ? 'calc(100vw - 50px)' : 480
  const dispatch = useDispatch()

  const [states, setStates] = useState({
    open: false,
    otp: '',
    generated: false,
    copied: false,
  })

  const handleClose = () => setStates(v => ({...v, open: false}))
  const handlers = useDefaultSavedHandlers('Generate One-Time Passcode')
  handlers.onSuccess.merge(useCallback(() => {
    dispatch({
      type: "OD/USER_INFO_SYNC_SUCCESS",
      payload: { data: { ...user, id: user.userId!, status: UserStatus.Inactive }},
      requestPayload: { id: user.userId! },
      meta: {
          resource: 'settings/organization/user-manage',
          fetchResponse: 'GET_ONE',
          fetchStatus: 'RA/FETCH_END',
      },
    })
  }, [dispatch, user]))

  return (
    <>
      <Tooltip title="Generate One-Time Passcode">
        <IconButton color="primary" onClick={() => setStates(v => ({...v, open: true}))}>
          <KeyIcon fontSize="small" />
        </IconButton>
      </Tooltip>
      <Drawer
        anchor="right"
        // onOpen={() => {}}
        // onClose={handleClose}
        open={states.open}
        PaperProps={{ sx: { p: 2, width: width, } }}
      >
        
        <Card sx={{  overflowY: 'auto', mb: 4, }} >
          <CardHeader title="Generate One-Time Passcode for user" />
          <CardContent>
            <Grid container spacing={4} >
              <Grid item xs={12}>
                <ReadonlyField label="User Account" value={user.username || ''} />
              </Grid>
              {states.generated &&
                <Grid item xs={12}>
                  <Alert severity="info" sx={{ mb: 3 }}>
                    Please copy the One-Time Passcode below and deliver it to the user above in a secure manner. This code is not accessible anymore once you close this dialog.
                  </Alert>
                  <ReadonlyField label="One-Time Passcode" id="code-copy" value={states.otp || ''} 
                    {...autoCopyTextFieldProps(
                      () => setStates(v => ({...v, copied: true})), 
                      () => setTimeout(() => setStates(v => ({...v, copied: false})), 500)
                    )}
                    {...{inputProps: {tabIndex: 0}}}
                  />
                </Grid>}
            </Grid>
          </CardContent>
          <Divider />
          <Stack direction="row" justifyContent="space-between" sx={{ p: 2 }} >
            <Button
              color="primary"
              type="button"
              variant="outlined"
              onClick={handleClose}
            >
              Close
            </Button>
            {!states.generated &&
              <Create resource="resetpassword-issue-otp" basePath="" {...handlers}>
                <WithSave
                  render={({save, saving}) =>
                    <Button variant="contained"
                      disabled={saving}
                      onClick={() => {
                        const payload = { targetUserId: user.userId! }
                        save(payload, {
                          onSuccess: ({data}: {data:{otp:string}}) => {
                            setStates(v => ({...v,
                              otp: data.otp, generated: true
                            }))
                          },
                        })
                      }}
                    >
                      Generate
                    </Button>
                  }
                />
              </Create>}
          </Stack>
        </Card>
      </Drawer>  
    
    </>
  )
}

export default GenOTPPassword;
